// extracted by mini-css-extract-plugin
module.exports = {"sdt-slider":"SubsDetailTextSlider_sdt-slider__Jgtsb","marquee":"SubsDetailTextSlider_marquee__8C10T"};